// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"BR","hoverImage":"CR","hovered":"DR","mainImage":"ER","imageNoBackground":"FR","fullSizeImage":"GR"};